var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWatchlist = function SvgWatchlist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 452.67 452.67",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.58,8.33A226.33,226.33,0,1,1,74.64,74.61,226.32,226.32,0,0,1,234.58,8.33Zm115.4,214a12.35,12.35,0,0,1,0,24.7H234.58A12.36,12.36,0,0,1,224,240.76l-.17-.17-.17-.35v-.17l-.17-.35-.18-.35v-.17l-.17-.35-.17-.17v-.35l-.17-.35v-.17l-.18-.35v-.7l-.17-.17V87.31a12.1,12.1,0,0,1,12.18-12.18,12.26,12.26,0,0,1,12.36,12.18v135ZM377.29,92a201.53,201.53,0,1,0,59.18,142.65A201.15,201.15,0,0,0,377.29,92Z",
    transform: "translate(-8.33 -8.33)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWatchlist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/watchlist.882df1ea.svg";
export { ForwardRef as ReactComponent };